import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const NoResultsState = ({ searchQuery, onClearSearch, onAddNewClient }) => {
  const suggestions = [
    "Check the spelling of the name or phone number",
    "Try searching with partial information",
    "Use only numbers for phone search (no dashes or spaces)",
    "Search by first name only if full name doesn't work"
  ];

  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      <div className="w-24 h-24 bg-muted rounded-full flex items-center justify-center mb-6">
        <Icon name="SearchX" size={32} className="text-muted-foreground" />
      </div>
      
      <h2 className="text-2xl font-semibold text-foreground mb-2">
        No clients found
      </h2>
      
      {searchQuery && (
        <p className="text-muted-foreground mb-6 max-w-md">
          We couldn't find any clients matching{' '}
          <span className="font-medium text-foreground">"{searchQuery}"</span>
        </p>
      )}

      {/* Search Suggestions */}
      <div className="bg-muted/30 rounded-lg p-6 mb-8 max-w-lg">
        <h3 className="text-sm font-semibold text-foreground mb-3 flex items-center">
          <Icon name="Lightbulb" size={16} className="mr-2 text-accent" />
          Search Tips
        </h3>
        <ul className="text-sm text-muted-foreground space-y-2 text-left">
          {suggestions.map((suggestion, index) => (
            <li key={index} className="flex items-start">
              <Icon name="ChevronRight" size={14} className="mr-2 mt-0.5 text-accent flex-shrink-0" />
              {suggestion}
            </li>
          ))}
        </ul>
      </div>

      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          variant="outline"
          onClick={onClearSearch}
          iconName="RotateCcw"
          iconPosition="left"
          iconSize={18}
          className="transition-all duration-200 hover:bg-muted"
        >
          Clear Search
        </Button>
        
        <Button
          variant="default"
          onClick={onAddNewClient}
          iconName="UserPlus"
          iconPosition="left"
          iconSize={18}
          className="bg-primary hover:bg-primary/90 text-primary-foreground transition-all duration-200 hover:shadow-md"
        >
          Add New Client
        </Button>
      </div>

      {/* Additional Help */}
      <div className="mt-8 p-4 bg-card border border-border rounded-lg max-w-md">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={16} className="text-primary mt-0.5 flex-shrink-0" />
          <div className="text-left">
            <p className="text-sm font-medium text-foreground mb-1">
              Can't find the client?
            </p>
            <p className="text-xs text-muted-foreground">
              They might not be registered yet. You can add them as a new client to start tracking their solarium minutes.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoResultsState;